import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

// import React, { useState } from 'react';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Features = () => {
  const [active, setActive] = useState<string>('feature1');
  const items = [
    'Click2File',
    'IRS2File',
    'Bulk Data Upload',
    'Guided Step-by-Step Filing ',
    'On-screen Help Text',
    'Automatic Tax Calculations',
    'EINFinder',
    'Form-based Filing Interface ',
    'Auto-populate Filing Data',
    'Multi-Year Filing Support',
    'Third-party software integrations ',
    'PayPal Payment Option',
    'Pay in Advance & Save',
    'Invite Friends',
    'Referral Program',
    'ZeroneCoins',
    'Mobile-friendly Filing',
    '24/7 Online Access ',
    'Tax Calculators',
    ' Filing Tools',
  ];
  const items1 = [
    'Advanced Error Checks',
    'Business Rule Validations',
    'IRS Form Validation',
    'Internal Audit Verification   ',
    'TIN Matching  ',
    'Advanced Error Detection',
    'USPS Address Validation',
    'Amendment  ',
    'Schedules ',
    'FREE W-9 Request Support ',
    'FREE W-8BEN Request Support',
    'Sub forms',
    'State Filing Support',
    'Superseded',
    'Corrections ',
    'FREE Retransmissions',
    'SOC 2 Type II Compliance ',
    'Encrypted Data Protection ',
    'Secure Cloud-based Access ',
  ];
  const items2 = [
    'Advanced Error Checks',
    'Business Rule Validations',
    'IRS Form Validation',
    'Internal Audit Verification   ',
    'TIN Matching  ',
    'Advanced Error Detection',
    'USPS Address Validation',
    'Amendment  ',
    'Schedules ',
    'FREE W-9 Request Support ',
    'FREE W-8BEN Request Support',
    'Sub forms',
    'State Filing Support',
    'Superseded',
    'Corrections ',
    'FREE Retransmissions',
    'Order History ',
    'Address Book Storage ',
  ];
  const items3 = [
    'ZeroneVault',
    'Two-Factor Authentication ',
    'Secure File Upload',
    'Deadline Reminder Emails',
    'Instant Notifications ',
    'Postal Mailing ',
    'Text Alerts',
    'Fax Alerts ',
    'Record Keeping ',
    'Manage Users',
    'Address Book Storage ',
    'Forms History Tracking',
    'Order History',
    'Download Previously Filed Forms',
    'Download & Share Forms',
    'Switch to Tax Professional',
    'Manage Users ',
  ];

  const sections = [
    {
      id: 'panel1',
      title: 'Smart Filing Features',
      items: [
        { id: 'feature1', title: 'Click2File' },
        {
          id: 'feature2',
          title: 'IRS2File (Import Previously Filed Details from the IRS)',
        },
        { id: 'feature3', title: 'Auto-populate Filing Data (Automagic2290) ' },
        { id: 'feature4', title: 'Bulk Data Upload' },
        { id: 'feature5', title: 'Guided Step-by-Step Filing' },
        { id: 'feature6', title: 'Form-based Filing Interface' },
        { id: 'feature7', title: 'On-screen Help Text' },
        { id: 'feature8', title: 'Automatic Tax Calculations' },
        { id: 'feature9', title: 'Multi-Year Filing Support (2023–2025) ' },
        { id: 'feature10', title: 'Third-party software integrations' },
        { id: 'feature11', title: 'EINFinder' },
      ],
    },

    {
      id: 'panel2',
      title: 'Advanced Data Validation',
      items: [
        { id: 'validation1', title: 'Advanced Error Checks' },
        { id: 'validation2', title: 'Business Rule Validations' },
        { id: 'validation3', title: 'IRS Form Validation' },
        { id: 'validation4', title: 'Internal Audit Verification  ' },
        { id: 'validation5', title: 'TIN Matching  ' },
        { id: 'validation6', title: 'Advanced Error Detection  ' },
        { id: 'validation7', title: 'USPS Address Validation' },
      ],
    },

    {
      id: 'panel3',
      title: 'Filing & Amendment Features',
      items: [
        { id: 'filing1', title: 'Amendment ' },
        { id: 'filing2', title: 'Schedules ' },
        { id: 'filing3', title: 'FREE VIN Correction for Form 2290 Filers ' },
        { id: 'filing4', title: 'FREE W-9 Request Support  ' },
        { id: 'filing5', title: 'FREE W-8BEN Request Support' },
        {
          id: 'filing6',
          title: 'FREE 94x Online Signature PIN Request Support',
        },
        { id: 'filing7', title: 'FREE Retransmissions of Rejected Returns ' },
        { id: 'filing8', title: 'State Filing Support for Selected Forms' },
        { id: 'filing9', title: 'Sub forms ' },
        { id: 'filing10', title: 'Superseded ' },
        { id: 'filing11', title: 'Corrections ' },
        { id: 'filing12', title: 'Electronic Signature & Authorization ' },
      ],
    },
    {
      id: 'panel4',
      title: 'Integrations',
      items: [
        { id: 'integration1', title: 'Xero Integration' },
        { id: 'integration2', title: 'QuickBooks Online Integration' },
        {
          id: 'integration3',
          title: 'FIRE-Formatted (Pub. 1220) File Support',
        },
        { id: 'integration4', title: 'EFW2 File Support' },
        { id: 'integration5', title: 'API Integration (W-9)' },
      ],
    },
    {
      id: 'panel5',
      title: 'Secure Access & Notifications ',
      items: [
        { id: 'secure1', title: 'ZeroneVault (Secure Portal) ' },
        { id: 'secure2', title: 'Two-Factor Authentication' },
        {
          id: 'secure3',
          title: 'Secure File Upload',
        },
        { id: 'secure4', title: 'Deadline Reminder Emails ' },
        { id: 'secure5', title: 'Instant Notifications ' },
        { id: 'secure6', title: 'Postal Mailing' },
        { id: 'secure7', title: 'Text Alerts ' },
        { id: 'secure8', title: 'Fax Alerts ' },
        { id: 'secure9', title: 'Record Keeping ' },
      ],
    },
    {
      id: 'panel6',
      title: 'Management Features',
      items: [
        { id: 'manage1', title: 'Multi-business Management' },
        { id: 'manage2', title: 'Workflow management' },
        {
          id: 'manage3',
          title: 'Manage Users',
        },
        { id: 'manage4', title: 'Address Book Storage' },
        { id: 'manage5', title: 'Forms History Tracking' },
        { id: 'manage6', title: 'Order History' },
        { id: 'manage7', title: 'Record Management Dashboard' },
        { id: 'manage8', title: 'Download Previously Filed Forms ' },
        {
          id: 'manage9',
          title: 'Download & Share Forms (for Client Review)  ',
        },
        { id: 'manage10', title: 'Switch to Tax Professional Account ' },
      ],
    },
    {
      id: 'panel7',
      title: 'Access & Convenience Features',
      items: [
        { id: 'access1', title: 'Mobile-friendly Filing' },
        { id: 'access2', title: 'Mobile App Support' },
        {
          id: 'access3',
          title: '24/7 Online Access',
        },
        { id: 'access4', title: 'Automatic Filing Reminders ' },
        { id: 'access5', title: 'Tax Calculators & Filing Tools ' },
      ],
    },
    {
      id: 'panel8',
      title: 'Security & Compliance Features',
      items: [
        { id: 'security1', title: 'Secure Cloud-based Access' },
        { id: 'security2', title: 'Encrypted Data Protection' },
        {
          id: 'security3',
          title: 'SOC 2 Type II Compliance',
        },
      ],
    },
    {
      id: 'panel9',
      title: 'Payment & Rewards Features ',
      items: [
        { id: 'pay1', title: 'PayPal Payment Option' },
        { id: 'pay2', title: 'Pay in Advance & Save' },
        {
          id: 'pay3',
          title: 'Invite Friends',
        },
        {
          id: 'pay4',
          title: 'Referral Program',
        },
        {
          id: 'pay5',
          title: 'Rewards Using ZeroneCoins',
        },
      ],
    },

    {
      id: 'panel10',
      title: 'Support Features',
      items: [
        { id: 'support1', title: '24/7 Customer Support ' },
        { id: 'support2', title: 'Knowledge Base & Support Center ' },
      ],
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          setActive(entry.target.id);

          if (['feature1', 'feature2', 'feature3'].includes(entry.target.id)) {
            setExpanded('panel1');
          }

          if (['validation1', 'validation2'].includes(entry.target.id)) {
            setExpanded('panel2');
          }

          if (['filing1', 'filing2'].includes(entry.target.id)) {
            setExpanded('panel3');
          }
          if (['integration1', 'integration2'].includes(entry.target.id)) {
            setExpanded('panel4');
          }
          if (['secure1', 'secure2'].includes(entry.target.id)) {
            setExpanded('panel5');
          }
          if (['manage1', 'manage2'].includes(entry.target.id)) {
            setExpanded('panel6');
          }
          if (['access1', 'access2'].includes(entry.target.id)) {
            setExpanded('panel7');
          }
          if (['security1', 'security2'].includes(entry.target.id)) {
            setExpanded('panel8');
          }
          if (['pay1', 'pay2'].includes(entry.target.id)) {
            setExpanded('panel9');
          }
          if (['support1', 'support2'].includes(entry.target.id)) {
            setExpanded('panel10');
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    document
      .querySelectorAll('.feature-section')
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const [expanded, setExpanded] = useState<string | false>('panel1');

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const [open, setOpen] = useState(false);
  return (
    <AppLayout
      meta={
        <Meta
          title="TaxZerone Features | All-in-One Tax Filing Platform"
          description="Explore TaxZerone’s smart IRS filing features including bulk uploads, e-filing, corrections, integrations, validations, and secure access for all businesses now"
          keywords="irs tax form for extension, irs form 4868,irs tax extension, irs extension online, irs form 7004, irs tax extension, form 4868 online, form 7004 online, form 8868 online, e file form 4868 tax extension, e file form 7004 tax extension"
          canonical="features/"
        />
      }
    >
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Box
        className="feature-bg"
        sx={{
          p: ' 190px 0 130px',
          marginTop: '0px',
          postion: 'relative',
          zIndex: 1,
          width: '100%',
        }}
      >
        <Box
          className="feature-container"
          sx={{
            width: '100vm',
            margin: 0,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
            }}
          >
            <Box
              className="features-track"
              sx={{
                display: 'flex',
                width: 'max-content',
                animation: 'scroll-left 60s linear infinite',
                '& .card': {
                  marginLeft: 2,
                  color: '#333',
                  textTransform: 'uppercase',
                  borderRadius: 3,
                  fontSize: 13,
                  p: 2,
                  textAlign: 'center',
                  backgroundImage:
                    'linear-gradient(90deg,rgba(255,255,255,0.50196) 0,#fff 100%);',
                },
              }}
            >
              {[...items, ...items].map((item, index) => (
                <Box key={index} className="card">
                  {item}
                </Box>
              ))}
            </Box>
            <Box
              className="features-track reverse"
              sx={{
                display: 'flex',
                whiteSpace: 'nowrap',
                willChange: 'transform',
                animation: 'scroll-right 60s linear infinite',
                '& .card': {
                  marginLeft: 2,
                  color: '#333',
                  textTransform: 'uppercase',
                  borderRadius: 3,
                  fontSize: 13,
                  p: 2,
                  textAlign: 'center',
                  backgroundImage:
                    'linear-gradient(90deg,rgba(255,255,255,0.50196) 0,#fff 100%);',
                },
              }}
            >
              {[...items1, ...items1].map((item1, index) => (
                <Box key={index} className="card">
                  {item1}
                </Box>
              ))}
            </Box>
            <Box
              className="features-track"
              sx={{
                display: 'flex',
                width: 'max-content',
                animation: 'scroll-left 60s linear infinite',
                '& .card': {
                  marginLeft: 2,
                  color: '#333',
                  textTransform: 'uppercase',
                  borderRadius: 3,
                  fontSize: 13,
                  p: 2,
                  textAlign: 'center',
                  backgroundImage:
                    'linear-gradient(90deg,rgba(255,255,255,0.50196) 0,#fff 100%);',
                },
              }}
            >
              {[...items2, ...items2].map((item2, index) => (
                <Box key={index} className="card">
                  {item2}
                </Box>
              ))}
            </Box>
            <Box
              className="features-track reverse"
              sx={{
                display: 'flex',
                whiteSpace: 'nowrap',
                willChange: 'transform',
                animation: 'scroll-right 60s linear infinite',
                '& .card': {
                  marginLeft: 2,
                  color: '#333',
                  textTransform: 'uppercase',
                  borderRadius: 3,
                  fontSize: 13,
                  p: 2,
                  textAlign: 'center',
                  backgroundImage:
                    'linear-gradient(90deg,rgba(255,255,255,0.50196) 0,#fff 100%);',
                },
              }}
            >
              {[...items3, ...items3].map((item3, index) => (
                <Box key={index} className="card">
                  {item3}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          className="feature-container-content"
          sx={{
            maxWidth: 1100,
            width: '100%',
            margin: '0 auto',
            position: 'absolute',
            top: { xs: '1.7%', sm: '395px', md: '384px !important' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            p: '130px 50px',
            borderRadius: '50%',
            boxSizing: 'border-box',
            zIndex: 1,

            '&::before': {
              width: '90%',
              height: '90%',
              content: '" "',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: -1,
              filter: 'blur(45px)',
              background:
                'radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 60%, rgba(255,255,255,0.9) 100%)',
              borderRadius: '50%',
            },
          }}
        >
          <Box>
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              TaxZerone Features:{' '}
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              <span className="highlight-container">
                <span className="highlight">All-In-One Solution</span>
              </span>{' '}
              for IRS Filing
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
            >
              Simplify IRS filing with an all-in-one platform. <br /> Upload,
              validate, e-file, and deliver forms with ease.
            </Typography>
            <Stack
              direction={{ xs: 'column-reverse', md: 'row' }}
              spacing={{ xs: 1, md: 6 }}
              justifyContent={{
                xs: 'center',
                md: 'center',
              }}
              alignItems="center"
              sx={{ mt: 4 }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  alignContent: 'center',
                  justifyContent: 'center',
                  mr: { xs: 0, md: 4 },
                }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  sx={{
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': {
                      transform: 'scale(1.1)',
                    },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=features`}
                >
                  E-file Now
                </Button>
              </Box>
              <Stack
                direction="row"
                spacing={2}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
              >
                <Box
                  sx={{
                    mb: { xs: '0 !important', md: '0px !important' },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/irs-authorized.webp" />
                    <source srcSet="/assets/images/irs-authorized.png" />
                    <Box
                      component="img"
                      src="/assets/images/irs-authorized.png"
                      loading="lazy"
                      alt="IRS-authorized e-file provider"
                      width={70}
                      height={69}
                      sx={{
                        width: { xs: 50, md: 70 },
                        height: { xs: 49, md: 69 },
                      }}
                    />
                  </picture>
                </Box>
                <Box
                  sx={{
                    mb: { xs: '0px !important', md: '0px !important' },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/tzo-soc2.webp" />
                    <source srcSet="/assets/images/tzo-soc2.png" />
                    <Box
                      component="img"
                      src="/assets/images/tzo-soc2.png"
                      loading="lazy"
                      alt="TZO SOC2 Compliant"
                      width={90}
                      height={89}
                      sx={{
                        width: { xs: 70, md: 90 },
                        height: { xs: 69, md: 89 },
                      }}
                    />
                  </picture>
                </Box>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="xl"
          sx={{
            my: { xs: 3, md: 3, lg: 8 },
            justifyContent: 'center',
            //   py: { xs: 2, sm: 3, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
            <Grid size={{ md: 2.3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  border: 'none',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  mx: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 36, md: 34, sm: 28, xs: 24 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  50+
                </Typography>
                <Typography variant="body1">Smart Features</Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 2.3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  border: 'none',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  mx: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 36, md: 34, sm: 28, xs: 24 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  2023–25
                </Typography>
                <Typography variant="body1">Multi-Year Support </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 2.3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  border: 'none',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  mx: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 36, md: 34, sm: 28, xs: 24 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  SOC 2
                </Typography>
                <Typography variant="body1">Type II Certified</Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 2.3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  border: 'none',
                  mx: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 36, md: 34, sm: 28, xs: 24 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  24/7
                </Typography>
                <Typography variant="body1">Access & Support </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 2.3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  border: 'none',
                  mx: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 36, md: 34, sm: 28, xs: 24 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  FREE
                </Typography>
                <Typography variant="body1">Retransmission </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ my: 4 }}>
        <Grid container spacing={2}>
          <Grid size={{ md: 3.5, sm: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                // px: 2,
                // py: 2,
                borderRadius: 1,
                textAlign: 'left',
                position: 'sticky',
                top: 90,
                height: 'fit-content',

                '& .MuiAccordionDetails-root': {
                  p: 0,
                },
                '& .css-1jq0wum-MuiList-root ': {
                  pt: 0,
                },
                '& .MuiAccordionSummary-content.Mui-expanded:before': {
                  content: "''",
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: '100%',
                  borderBottom: '3px solid #1da94a',
                },
              }}
            >
              {sections.map((group) => (
                <Accordion
                  key={group.id}
                  expanded={expanded === group.id}
                  onChange={handleChange(group.id)}
                  aria-controls="resource-content-excise"
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={500} sx={{ fontSize: { md: 16 } }}>
                      {group.title}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails sx={{ p: 0 }}>
                    <List disablePadding>
                      {group.items.map((item) => (
                        <ListItemButton
                          key={item.id}
                          selected={active === item.id}
                          onClick={() =>
                            document.getElementById(item.id)?.scrollIntoView({
                              behavior: 'smooth',
                              block: 'start',
                            })
                          }
                        >
                          <ListItemText primary={item.title} />
                        </ListItemButton>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Paper>
          </Grid>

          <Grid size={{ md: 8.5, sm: 8, xs: 12 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                borderRadius: 1,
              }}
            >
              {/* <Box>
                {sections.map((item) => (
                  <Box
                    key={item.id}
                    id={item.id}
                    className="feature-section"
                    sx={{
                      // minHeight: '100vh',
                      // py: 8,
                      scrollMarginTop: '100px',
                      // borderBottom: '1px solid #e5e7eb',

                      display: 'flex',
                      alignItems: 'center',
                      mb: 3,
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h3"
                        sx={{
                          mb: 1,
                          fontWeight: 600,
                          fontSize: { md: 22, sm: 20, xs: 18 },
                        }}
                      >
                        {item.title}
                      </Typography>

                      <Typography
                        color="text.secondary"
                        sx={{ color: 'rgb(68, 68, 68)' }}
                      >
                        Click2File is a fast-filing feature in TaxZerone that
                        lets users file tax forms quickly by automatically
                        importing previously entered information. It reduces
                        manual data entry and speeds up the e-filing process.
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box> */}

              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Smart Filing Features
              </Typography>
              <Box
                id="feature1"
                className="feature-section"
                sx={{ scrollMarginTop: '100px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Click2File
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  {' '}
                  <Link
                    href="/excise-tax/click2file-form-2290/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Click2File
                  </Link>{' '}
                  is a fast-filing feature in{' '}
                  <Link href="/" sx={{ color: '#0202ff' }}>
                    TaxZerone
                  </Link>{' '}
                  that lets users file tax forms quickly by automatically
                  importing previously entered information. It reduces manual
                  data entry and speeds up the e-filing process.
                </Typography>
              </Box>
              <Box
                id="feature2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  IRS2File (Import Previously Filed Details from the IRS)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  {' '}
                  Automatically imports previously filed IRS return information
                  to help users start filing faster and reduce manual entry.
                </Typography>
              </Box>
              <Box
                id="feature3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Automagic2290
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  {' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Auto-populate Filing Data (
                    <Link
                      href="/resources/excise-tax/automagic2290/"
                      sx={{ color: '#0202ff' }}
                    >
                      Automagic2290
                    </Link>
                    )
                  </span>{' '}
                  is a TaxZerone feature that automatically fills in Form 2290
                  details by importing from a previously filed Form 2290PDF. It
                  helps users avoid repetitive manual entry, speeds up the
                  filing process, and improves accuracy by pre-filling business,
                  vehicle, and tax data.
                </Typography>
              </Box>
              <Box
                id="feature4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Bulk Data Upload
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Upload thousands of records at once using Excel, CSV, or
                  custom templates. Simply fill in your return data and upload
                  the file to automatically generate multiple returns in
                  minutes—eliminating the need to create returns individually.
                  Need a template?{' '}
                  <span style={{ fontWeight: 600 }}>
                    Download our Bulk Upload Template
                  </span>{' '}
                  to get started quickly
                </Typography>
              </Box>
              <Box
                id="feature5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Guided Step-by-step filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  A structured, guided workflow takes you from entering business
                  details through final submission — with clear instructions at
                  every stage. Reduces confusion and minimizes errors for
                  first-time and experienced filers alike.
                </Typography>
              </Box>
              <Box
                id="feature6"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Form-based Filing Interface
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Users can enter information directly into organized digital
                  forms with clear field labels, built-in validations, and easy
                  navigation, making the filing process simple, accurate, and
                  efficient.
                </Typography>
              </Box>
              <Box
                id="feature7"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  On-screen Help Text
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Helpful tips and field explanations appear directly next to
                  each input while you fill out the form. You don’t need to
                  leave the page or open another guide — the information you
                  need is already available on the screen.
                </Typography>
              </Box>
              <Box
                id="feature8"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Automatic Tax Calculations
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Automatically calculates tax amounts based on the information
                  entered by the user. It helps reduce manual effort, improve
                  accuracy, and make the filing process faster and easier.
                </Typography>
              </Box>
              <Box
                id="feature9"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Multi-Year Filing Support (2023–2025)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  TaxZerone supports multi-year filing Support for the users to
                  file tax returns for different tax years within a single
                  platform. Whether you are working on current-year filings or
                  need to complete returns for previous years, the system lets
                  you manage everything in one place without switching tools or
                  systems.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This feature helps users easily access past filings, continue
                  unfinished returns, and maintain organized records across
                  multiple years. It improves efficiency, reduces confusion, and
                  ensures a smoother filing experience for businesses, tax
                  professionals, and recurring filers handling multiple tax
                  periods.
                </Typography>
              </Box>
              <Box
                id="feature10"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Third-party software integrations
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Connect accounting tools like{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    QuickBooks, Xero, and more
                  </span>{' '}
                  to TaxZerone to import financial data directly into your tax
                  forms. This eliminates duplicate data entry, reduces manual
                  work, and helps keep your financial records and tax filings in
                  sync.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It streamlines the entire workflow, improves accuracy, and
                  makes tax preparation faster and more efficient for businesses
                  and professionals.
                </Typography>
              </Box>
              <Box
                id="feature11"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  EINFinder
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  {' '}
                  <Link
                    href="https://einfinder.taxzerone.com/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    EINFinder
                  </Link>{' '}
                  is a smart lookup tool that automatically retrieves
                  organization details using the organization’s Employer
                  Identification Number (EIN). It helps nonprofit organizations
                  quickly access registered information, reduce manual data
                  entry, and complete Form 990-N filing more accurately and
                  efficiently.
                </Typography>
              </Box>

              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Advanced Data Validation
              </Typography>

              <Box
                id="validation1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Advanced Error checks{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Real-time alerts for invalid pay period dates, duplicate SSNs,
                  and data issues — validated continuously as you enter each
                  record so you fix problems immediately, not after submission.
                </Typography>
              </Box>
              <Box
                id="validation2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Business Rule Validations
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Auto-checks your data against IRS rules, logical conditions,
                  and form-specific requirements. Catches invalid dates,
                  duplicate records, and missing fields before submission.
                </Typography>
              </Box>
              <Box
                id="validation3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  IRS Form validation
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  TaxZerone validates your IRS forms for accuracy, completeness,
                  and compliance before submission. Detect errors instantly and
                  reduce filing rejections, penalties, and costly corrections.
                </Typography>
              </Box>
              <Box
                id="validation4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Internal Audit Verification
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It helps users review and verify filing data before submission
                  by checking for inconsistencies, missing information, and
                  potential errors within the records. This additional
                  verification process supports better data accuracy, improves
                  compliance, and helps businesses maintain organized and
                  reliable filing records.
                </Typography>
              </Box>
              <Box
                id="validation5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  TIN Matching
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Verifies Taxpayer Identification Number (TIN) and taxpayer
                  name entered in the filing records to match IRS records.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This validation process helps reduce filing errors, improve
                  data accuracy, and minimize the risk of IRS notices,
                  penalties, or rejected returns caused by incorrect taxpayer
                  information.
                </Typography>
              </Box>
              <Box
                id="validation6"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Advanced Error Detection
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Scans for mistakes, missing fields, duplicate entries, and
                  inconsistencies at both data and form level. Two layers of
                  checking mean far fewer rejections and a smoother e-filing
                  experience.
                </Typography>
              </Box>
              <Box
                id="validation7"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  USPS Address Validation
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Checks and standardizes mailing addresses using USPS-approved
                  postal data — ensuring tax documents reach recipients
                  accurately and on time, every time.
                </Typography>
              </Box>

              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Filing & Amendment Features
              </Typography>
              <Box
                id="filing1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Amendment
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Fix errors or update details on previously filed forms.
                  TaxZerone prepares and files amended returns quickly and
                  accurately to keep you IRS compliant.
                </Typography>
              </Box>
              <Box
                id="filing2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Schedules
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It supports various IRS schedules, making it easier to
                  complete and file detailed tax information accurately. It
                  helps users manage supporting schedules alongside their main
                  tax forms, ensuring organized reporting and IRS compliance.
                  With a streamlined workflow and guided filing process, you can
                  handle schedules efficiently while reducing manual effort and
                  errors.
                </Typography>
              </Box>
              <Box
                id="filing3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  FREE VIN Correction for Form 2290 Filers
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Correct an incorrect Vehicle Identification Number on a
                  previously filed Form 2290 at zero cost — without refiling the
                  entire return. Your vehicle records stay accurate, your wallet
                  stays intact.
                </Typography>
              </Box>
              <Box
                id="filing4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  FREE W-9 Request Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Request and collect{' '}
                  <Link
                    href="/request-form-w9-online-free/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    W-9 forms
                  </Link>{' '}
                  from vendors and contractors directly through the platform. No
                  manual follow-ups, no spreadsheets — everything you need
                  before 1099 filing, handled automatically.
                </Typography>
              </Box>
              <Box
                id="filing5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  FREE W-8BEN Request Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Collect{' '}
                  <Link
                    href="/request-form-w8ben-online-free/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    W-8BEN forms
                  </Link>{' '}
                  from international vendors and contractors with secure,
                  streamlined request management — maintaining compliance for
                  global payee relationships at no extra charge.
                </Typography>
              </Box>
              <Box
                id="filing6"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  FREE 94x Online Signature PIN Request Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Request the IRS-required 94x Online Signature PIN for
                  electronic filing of Forms{' '}
                  <Link
                    href="/resources/employment-tax/form-941-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    941
                  </Link>
                  ,{' '}
                  <Link
                    href="/resources/employment-tax/form-940-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    940
                  </Link>
                  ,{' '}
                  <Link
                    href="/resources/employment-tax/form-943-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    943
                  </Link>
                  ,{' '}
                  <Link
                    href="/resources/employment-tax/form-944-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    944
                  </Link>
                  , and{' '}
                  <Link
                    href="/resources/employment-tax/form-945-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    945
                  </Link>
                  — completely <span style={{ fontWeight: 600 }}> FREE</span>{' '}
                  with TaxZerone. No paper, no delays — the authorization
                  process simplified entirely.
                </Typography>
              </Box>
              <Box
                id="filing7"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Free Retransmissions of Rejected Return
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It allows users to retransmit rejected returns at no
                  additional cost. If a return is rejected due to errors or
                  missing information, users can correct the issue and resubmit
                  the return quickly without paying extra filing fees. This
                  helps ensure a smoother and more cost-effective filing
                  experience.
                </Typography>
              </Box>
              <Box
                id="filing8"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  State Filing Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Submit 1099 and W-2 state filings directly to participating
                  state agencies alongside federal returns. Federal and state
                  compliance handled together on one platform — no dual workflow
                  is needed.
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note: </b> TaxZerone supports{' '}
                  <Link
                    href="/form-1099-state-filing/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    1099 state filings
                  </Link>{' '}
                  and{' '}
                  <Link href="/form-w2-state-filing/" sx={{ color: '#0202ff' }}>
                    {' '}
                    w2 State filings
                  </Link>{' '}
                  and also 100s for business tax forms in California state
                </Alert>
              </Box>
              <Box
                id="filing9"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Sub forms
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  TaxZerone’s Sub Forms feature helps users include additional
                  supporting forms required along with the main tax return.
                  These sub forms are designed to capture detailed and specific
                  information that cannot be accommodated within the primary
                  form, ensuring complete and accurate reporting.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  By organizing complex tax data into structured sections, this
                  feature improves filing accuracy, reduces errors, and ensures
                  full IRS compliance. It also simplifies the filing process by
                  making it easier for users to enter, review, and submit all
                  required information in one place.
                </Typography>
              </Box>
              <Box
                id="filing10"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Superseded
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  TaxZerone supports superseded returns, allowing you to replace
                  a previously filed return with an updated version before the
                  filing deadline.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This feature helps users correct errors, update information,
                  and submit revised data without starting the process from
                  scratch. With a streamlined correction workflow, you can
                  maintain accurate records and ensure compliant tax filings
                  with confidence.
                </Typography>
              </Box>
              <Box
                id="filing11"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Corrections
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Need to fix a filing error? TaxZerone makes it easy to submit
                  corrections for eligible tax forms, update information, and
                  keep your tax records accurate and compliant.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Dedicated support for correction filings, including{' '}
                  <Link
                    href="/information-returns/efile-irs-form-1099-corrections/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    1099 Corrections
                  </Link>
                  ,{' '}
                  <Link
                    href="/information-returns/efile-irs-form-w2-c/"
                    sx={{ color: '#0202ff' }}
                  >
                    W-2C
                  </Link>
                  ,{' '}
                  <Link
                    href="/employment-tax/efile-irs-form-941-x-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 941-X
                  </Link>
                  , <br />
                  <Link
                    href="/employment-tax/e-file-irs-form-943-x/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 943-X
                  </Link>
                  , and{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-945-x/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 945-X
                  </Link>
                  . Update taxpayer information, correct filing errors, and
                  resubmit amended returns while maintaining compliance with IRS
                  requirements.
                </Typography>
              </Box>
              <Box
                id="filing12"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Electronic Signature & Authorization
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Approve and authorize tax documents digitally. Eliminates
                  paper signatures, speeds up the filing process, and supports
                  secure multi-party authorization workflows for businesses and
                  professionals.
                </Typography>
              </Box>

              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Integrations
              </Typography>
              <Box
                id="integration1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Xero
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Connect Xero to pull financial records straight into TaxZerone
                  for faster and more accurate filing of forms such as 1099 and
                  W-2. Eliminate duplicate data entry and keep your accounting
                  and tax filing information perfectly aligned without switching
                  between multiple tools.
                </Typography>
              </Box>
              <Box
                id="integration2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  QuickBooks Online Integration
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Import financial and payroll data directly from QuickBooks
                  Online into your tax forms. Automatic sync reduces manual
                  entry and improves data accuracy across all 1099 and W-2
                  filings.
                </Typography>
              </Box>
              <Box
                id="integration3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  FIRE-Formatted (Pub. 1220) File Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Upload IRS FIRE-formatted bulk information returns compliant
                  with Publication 1220. Built-in validation ensures files meet
                  every IRS electronic filing standard before they're
                  transmitted.
                </Typography>
              </Box>
              <Box
                id="integration4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  EFW2 File Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Import W-2 wage and tax statement data via EFW2 structured
                  file format. Direct upload eliminates manual entry and
                  minimizes errors when processing large W-2 batches.
                </Typography>
              </Box>
              <Box
                id="integration5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  API Integration (W-9)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Embed W-9 collection directly into your own systems via API.
                  Automate requests, capture data securely, and sync it in
                  real-time with TaxZerone — no manual handoff between
                  platforms.
                </Typography>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Secure Access & Notifications
              </Typography>
              <Box
                id="secure1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  ZeroneVault (Secure Portal)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}> ZeroneVault</span> is
                  TaxZerone's secure online portal for sending, receiving,
                  signing, sharing, and storing tax documents electronically. It
                  enables recipients to securely access and download forms such
                  as 1099s, W-2s, and Schedule K-1s from a centralized location.
                  With built-in e-signature capabilities and secure document
                  sharing, ZeroneVault eliminates the need for paper copies,
                  making tax document management faster, easier, and more
                  convenient for businesses and recipients.
                </Typography>
              </Box>
              <Box
                id="secure2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Two-Factor Authentication
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Two-Factor Authentication (2FA) is a security feature that
                  adds an extra layer of protection to user accounts. In
                  addition to entering a password, users must verify their
                  identity using a second step, such as a verification code sent
                  to their mobile device.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  In TaxZerone, it helps protect sensitive tax and business
                  information by preventing unauthorized access and improving
                  account security.
                </Typography>
              </Box>
              <Box
                id="secure3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Secure File Upload
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Upload documents, spreadsheets, and supporting files through
                  an encrypted, protected channel. Sensitive business and
                  taxpayer information is transferred safely at every step.
                </Typography>
              </Box>
              <Box
                id="secure4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Deadline Reminder Emails
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Advance notifications before every major IRS filing deadline.
                  Stay ahead of due dates and avoid late-filing penalties
                  without managing a separate tax calendar.
                </Typography>
              </Box>
              <Box
                id="secure5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Instant Notifications
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  TaxZerone sends instant notifications to keep users updated on
                  important filing activities such as submission status, IRS
                  acceptance or rejection, corrections, and upcoming actions.
                  These real-time alerts help users stay informed, respond
                  quickly, and manage their tax filings more efficiently.
                </Typography>
              </Box>
              <Box
                id="secure6"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Postal Mailing
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Send printed tax documents to recipients through physical mail
                  directly from the platform. Reduces manual mailing effort and
                  ensures forms are delivered accurately and on time.
                </Typography>
              </Box>
              <Box
                id="secure7"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Text Alerts
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  IRS decisions, filing status updates, and correction
                  notifications sent directly to your mobile phone. Instant
                  updates wherever you are — no logging in to check.
                </Typography>
              </Box>
              <Box
                id="secure8"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Fax Alerts
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Receive filing updates and document notifications via fax for
                  businesses that rely on fax-based communication for tax
                  records, compliance documentation, and filing management.
                </Typography>
              </Box>
              <Box
                id="secure9"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Record Keeping
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  All filed tax forms and related documents are stored securely
                  inside your account dashboard with at least 3 years. Download,
                  review, and manage previous filings any time for audits,
                  corrections, or reference.
                </Typography>
              </Box>

              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Management Features
              </Typography>
              <Box
                id="manage1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Multi-business Management
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  TaxZerone makes it easy to manage filings for multiple
                  businesses from a single account. Whether you’re a business
                  owner, CPA, or tax professional handling multiple clients, it
                  allows you to organize business records, switch between
                  entities seamlessly, and manage filings efficiently in one
                  centralized dashboard.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This streamlined approach helps save time, reduce complexity,
                  and improve overall workflow management.
                </Typography>
              </Box>
              <Box
                id="manage2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Workflow management
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Simplify and organize your entire tax filing process with a
                  centralized workflow system. Assign returns to preparers,
                  route completed forms for review, collect approvals, and track
                  filing status in real time. Stay on top of deadlines, manage
                  team responsibilities, and ensure every return moves smoothly
                  from preparation to submission—helping your team stay
                  efficient, accurate, and compliant.
                </Typography>
              </Box>
              <Box
                id="manage3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Manage Users & Permissions
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Easily add team members, assign user roles, and control access
                  to your organization's tax data. Set permissions based on
                  responsibilities such as{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Preparer, Reviewer, and Approver,
                  </span>{' '}
                  ensuring each user has the appropriate level of access while
                  maintaining security, accuracy, and workflow efficiency.
                </Typography>
              </Box>
              <Box
                id="manage4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Address Book Storage
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Save payer, recipient, employee, and business contact details
                  for the future filings. No re-entering the same data twice —
                  contacts are stored, searchable, and always ready.
                </Typography>
              </Box>
              <Box
                id="manage5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Forms History Tracking
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  You can easily track and monitor the complete history and
                  status of your filed tax forms. Users can view submission
                  records, IRS acceptance or rejection status, corrections,
                  updates, and filing activities from one centralized location.
                </Typography>
              </Box>
              <Box
                id="manage6"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Order History
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  It provides a complete record of your previous orders,
                  including filing purchases, payment details, and related
                  activities in one place.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This feature makes it easy to track past transactions, stay
                  organized, and quickly access order information whenever
                  required for reference or reporting.
                </Typography>
              </Box>
              <Box
                id="manage7"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Record Management Dashboard
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  View, track, download, and manage all your tax filing
                  information from one structured dashboard in TaxZerone.
                  Everything organized, everything findable, nothing scattered
                  across different menus.
                </Typography>
              </Box>
              <Box
                id="manage8"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Download Previously Filed Forms
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Quickly access and download your previously filed tax forms
                  and supporting documents from your TaxZerone account whenever
                  needed.
                </Typography>
              </Box>
              <Box
                id="manage9"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Download & Share Forms (for Client Review)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It allows users to download filed forms such as 1099s, W-2s,
                  and other tax returns and securely share them with clients for
                  review and also helps accountants and businesses collaborate
                  easily, make necessary corrections if needed, and ensure
                  accurate filings before final use or submission
                </Typography>
              </Box>
              <Box
                id="manage10"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Switch to Tax Professional Account
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  You can switch to a Tax Professional Account in TaxZerone to
                  manage multiple clients and handle their tax filings from a
                  single dashboard. This feature is designed for accountants and
                  tax professionals, allowing them to organize client accounts,
                  streamline filing workflows, and efficiently manage multiple
                  returns in one place.
                </Typography>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Access & Convenience Features
              </Typography>
              <Box
                id="access1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Mobile-friendly Filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Complete your tax filing easily using a smartphone or tablet
                  without needing a desktop. It provides a responsive and
                  user-friendly interface that allows you to enter data, upload
                  documents, and submit forms anytime and anywhere.
                </Typography>
              </Box>
              <Box
                id="access2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Mobile App Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  TaxZerone’s Mobile App allows you to manage your tax filings
                  on the go with ease and flexibility. Whether you’re using a
                  smartphone or tablet, you can conveniently prepare and file
                  forms such as Form 2290, Form 4868, Form 7004, Form 8868, Form
                  990-N and ZeroneVault anytime, anywhere.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It provides access to key features, easy data entry, and
                  real-time filing status updates, ensuring a smooth and
                  user-friendly experience even when you’re away from your
                  desktop.
                </Typography>
              </Box>

              <Box
                id="access3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  24/7 Online Access
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  TaxZerone provides 24/7 online access, allowing users to reach
                  the platform anytime they need. Whether it is filing taxes,
                  uploading documents, or tracking filing status, users can
                  access services without time restrictions. This ensures
                  continuous availability and a convenient filing experience
                  whenever support or action is required.
                </Typography>
              </Box>
              <Box
                id="access4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Automatic Filing Reminders
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Advance deadline alerts sent automatically before every major
                  IRS due date. Never miss a filing deadline or face an
                  avoidable penalty again.
                </Typography>
              </Box>

              <Box
                id="access5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Tax Calculators & Filing Tools
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Built-in calculators for{' '}
                  <Link
                    href="/tools/form-2290-tax-calculator/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 2290
                  </Link>{' '}
                  and{' '}
                  <Link
                    href="/tools/form-7004-due-date-calculator/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    7004
                  </Link>{' '}
                  — auto-compute tax values and guide you through the complete
                  submission process step by step.
                </Typography>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Security & Compliance Features
              </Typography>
              <Box
                id="security1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Secure Cloud-based Access
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Access your TaxZerone account anytime, anywhere with secure
                  cloud-based technology. All your tax data is safely stored and
                  managed in the cloud, ensuring seamless accessibility across
                  devices without compromising security. This allows users to
                  work flexibly, collaborate efficiently, and manage filings
                  with confidence from any location.
                </Typography>
              </Box>
              <Box
                id="security2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Encrypted Data Protection
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  TaxZerone ensures your sensitive tax information is fully
                  protected with advanced encryption standards. All data is
                  securely encrypted during transmission and storage, helping
                  prevent unauthorized access and maintaining complete
                  confidentiality.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This strong layer of protection keeps your financial and
                  personal information safe at every step of the filing process.
                </Typography>
              </Box>

              <Box
                id="security3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  SOC 2 Type II Compliance
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  TaxZerone follows SOC 2 Type II compliance standards to ensure
                  the highest level of security, availability, and
                  confidentiality of user data. This certification reflects our
                  commitment to maintaining strict internal controls, secure
                  systems, and continuous monitoring.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It provides users with confidence that their information is
                  handled through a trusted and audited security framework.
                </Typography>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Payment & Rewards Features
              </Typography>
              <Box
                id="pay1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  PayPal Payment Option
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Pay securely and conveniently using PayPal. This flexible
                  payment method allows users to complete transactions quickly
                  while ensuring safe, encrypted processing for every filing.
                </Typography>
              </Box>
              <Box
                id="pay2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Pay in Advance & Save 
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Take advantage of TaxZerone’s Pay in Advance option to plan
                  your filings early and reduce last-minute costs. This feature
                  helps you stay ahead of deadlines while enjoying better value
                  and smoother tax preparation.
                </Typography>
              </Box>
              <Box
                id="pay3"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Invite Friends
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Invite colleagues, clients, and friends to TaxZerone. Help
                  your network file smarter while building your ZeroneCoins
                  balance — with no ceiling on what you can earn.
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note: </b> Earn rewards when your friends file with
                  TaxZerone—you get{' '}
                  <span style={{ fontWeight: 600 }}> 20%</span> for every
                  successful referral, and they receive{' '}
                  <span style={{ fontWeight: 600 }}> 20% </span> off their
                  filing. It’s a straightforward, win-win way to save more, earn
                  more, and grow your network with no limits.
                </Alert>
              </Box>
              <Box
                id="pay4"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Referral Program
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Earn 20% back for every successful referral. Your friend gets
                  20% off their first filing. No caps, no limits — a
                  straightforward win-win that scales with your network.
                </Typography>
                <Box
                  sx={{
                    mb: 3,
                    background:
                      'linear-gradient(90deg,rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 48%, rgba(0, 255, 60, 0.5) 100%)',
                    p: 1.2,
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0, color: '#d9d9d9' }}>
                    Get up to a{' '}
                    <span style={{ fontWeight: 600, color: '#fff' }}> 20%</span>{' '}
                    referral bonus for every successful referral{' '}
                  </Typography>
                </Box>
              </Box>
              <Box
                id="pay5"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Rewards Using ZeroneCoins
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  You earn ZeroneCoins by referring your friends and family to
                  file their tax forms with TaxZerone. When your referred friend
                  completes their first tax filing, 20% of their filing fee is
                  converted into ZeroneCoins and automatically credited to your
                  account.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  These ZeroneCoins can be used to unlock benefits and savings
                  on future filings, making every successful referral more
                  rewarding for you.
                </Typography>
              </Box>

              <Typography
                variant="h3"
                sx={{
                  p: 2,
                  backgroundColor: '#f0f2f9',
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Support Features
              </Typography>
              <Box
                id="support1"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  24/7 Customer Support
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  <Link href="/contact-us/" sx={{ color: '#0202ff' }}>
                    {' '}
                    Live chat and email support
                  </Link>{' '}
                  available 24/7 — every day, every time zone. Whether you need
                  help with filing questions, technical issues, or account
                  support, our team is ready to assist you quickly — without
                  waiting for business hours. We’re here when IRS deadlines
                  matter most.
                </Typography>
              </Box>
              <Box
                id="support2"
                className="feature-section"
                sx={{ scrollMarginTop: '80px' }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 18, xs: 18 },
                  }}
                >
                  Knowledge Base & Support Center
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  <Link
                    href="https://support.taxzerone.com/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Step-by-step articles, FAQs, and tutorials
                  </Link>{' '}
                  covering every aspect of filing on TaxZerone. From first-time
                  filers to bulk-submission power users — find instant answers
                  without waiting for a support agent.
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to Simplify Your IRS Filing Process?
        </Typography>
        <Container maxWidth="md" sx={{ px: 0 }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              color: '#f3f3f3',
              mb: 3,
              lineHeight: 1.5,
            }}
          >
            From smart automation and bulk uploads to secure filing,
            corrections, integrations, and compliance tools — TaxZerone gives
            businesses, enterprises, and tax professionals everything needed to
            manage IRS filings efficiently on one platform.
          </Typography>
        </Container>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=features`}
          >
            E-File Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default Features;
